let inputID = 0;

document.querySelectorAll('label.input').forEach(label => {
    const name = label.htmlFor;
    const type = label.dataset.type;
    const iconName = label.dataset.icon;
    const hint = label.dataset.hint;
    const validate = label.dataset.validate;
    const disabled = label.hasClass('disabled');
    const autofocus = label.hasClass('autofocus');

    let input = document.createElement('input');
    input.type = type;
    input.id = 'input-' + inputID;
    input.name = name;
    if ('value' in label.dataset) input.setAttribute('value', label.dataset.value);
    input.placeholder = ' ';
    input.disabled = disabled;
    label.htmlFor = 'input-' + inputID;
    inputID++;

    label.innerHTML = '<span class="label">' + label.innerHTML + '</span>';
    label.prepend(input);

    if ('icon' in label.dataset) {
        let icon = document.createElement('span');
        icon.addClass('material-symbols-outlined');
        icon.innerHTML = iconName;
        label.append(icon);
        label.addClass('icon');
    }

    if ('validate' in label.dataset) {
        input.addClass('validate');
        input.dataset.validate = validate;
        if ('min' in label.dataset) input.dataset.min = label.dataset.min;
        if ('max' in label.dataset) input.dataset.max = label.dataset.max;
    }

    if (autofocus) label.focus();

    if ('hint' in label.dataset) {
        let hintElement = document.createElement('span');
        hintElement.addClass('hint');
        hintElement.innerHTML = `&nbsp;(${hint})`;
        label.querySelector('span.label').append(hintElement);
    }
})